<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="单价设置" name="MeterOrderPrice">
        <MeterOrderPriceMain v-if="card_index==='MeterOrderPrice'" />
      </el-tab-pane>
      <el-tab-pane label="固定金额" name="MeterOrderFixedMain">
        <MeterOrderFixedMain v-if="card_index==='MeterOrderFixedMain'" />
      </el-tab-pane>

      <el-tab-pane  label="用量计费" name="MeterOrderList">
        <template slot="label">
          <span v-if="user_type==1">费用计算</span>
          <span v-if="user_type==2">用量计费</span>
        </template>
        <MeterOrderList v-if="card_index==='MeterOrderList'" />
      </el-tab-pane>

      <el-tab-pane label="分摊计费" name="MeterOrderObjectList">
        <template slot="label">
          <span v-if="user_type==1">明细计费</span>
          <span v-if="user_type==2">分摊计费</span>
        </template>
        <MeterOrderObjectList v-if="card_index==='MeterOrderObjectList'" />
      </el-tab-pane>

      <el-tab-pane label="用户费用" name="MeterUserOrderList">
        <MeterUserOrderList v-if="card_index==='MeterUserOrderList'" />
      </el-tab-pane>

<!--      <el-tab-pane v-if="user_type==2" label="用量计费" name="MeterOrderList">-->
<!--        <MeterOrderList v-if="card_index==='MeterOrderList'" />-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane v-if="user_type==2" label="分摊计费" name="MeterOrderObjectList">-->
<!--        <MeterOrderObjectList v-if="card_index==='MeterOrderObjectList'" />-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane v-if="user_type==2" label="用户费用" name="MeterUserOrderList">-->
<!--        <MeterUserOrderList v-if="card_index==='MeterUserOrderList'" />-->
<!--      </el-tab-pane>-->
      <el-tab-pane label="费用异动" name="MeterOrderUnusualChange">
        <MeterOrderUnusualChange v-if="card_index==='MeterOrderUnusualChange'" />
      </el-tab-pane>
      <el-tab-pane label="审批流程" name="MeterOrderUserFlow">
        <MeterOrderUserFlow v-if="card_index==='MeterOrderUserFlow'" />
      </el-tab-pane>
      <el-tab-pane v-if="user_type==2" label="分摊公示" name="MeterOrderPublicityList">
        <MeterOrderPublicityList v-if="card_index==='MeterOrderPublicityList'" />
      </el-tab-pane>
<!--      <el-tab-pane label="线路图" name="MeterMapList">-->
<!--&lt;!&ndash;        <MeterMapList v-if="card_index==='MeterMapList'"/>&ndash;&gt;-->
<!--      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import MeterOrderList from "./MeterOrderList";
import MeterOrderNoteList from "./MeterOrderNoteList";
import MeterOrderObjectList from "./MeterOrderObjectList";
import MeterOrderPublicityList from "./MeterOrderPublicityList";
import MeterUserOrderList from "./MeterUserOrderList";
import MeterOrderFeeItemAnnotation from "./MeterOrderFeeItemAnnotation";
import MeterOrderPriceMain from "./components/MeterOrderPriceMain";
import MeterOrderFixedMain from "./components/MeterOrderFixedMain";
import MeterOrderUnusualChange from "./MeterOrderUnusualChange";
import MeterOrderUserFlow from "./MeterOrderUserFlow";
// import MeterMapList from "./MeterMapList";
export default {
  name: "MeterMain",
  components: {
    MeterOrderUserFlow,
    MeterOrderUnusualChange,
    MeterOrderNoteList,MeterOrderPriceMain, MeterUserOrderList, MeterOrderPublicityList, MeterOrderObjectList, MeterOrderList,MeterOrderFeeItemAnnotation, MeterOrderFixedMain},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"MeterOrderList"
    }
  },
  computed:{
    user_type(){
      return this.$route.query.type
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderMain.vue